// @vendors
const { getStore } = require('core/storeHelper');
const moment = require('moment');

// @constants
const { DATE_FORMAT_SLASHED_ES } = require('constants/index');
const { DISPLAY_CONVENIENCE_TEST_QUESTION_ZERO } = require('constants/flagBasedFeatures');
// @utilites
const DateHelper = require('utilities/dateHelper');

const isMiFIDValid = () => {
    const immBrokerConsultMiFID = getStore().getState().brokerConsultMiFID;
    const immBrokerConvenienceMiFIDTest = getStore().getState().brokerConvenienceMiFIDTest;
    const immBrokerConsultMiFIDWasFetched = immBrokerConsultMiFID.get('fetched');
    let testDone, dateMiFIDWasMade;
    if(immBrokerConsultMiFIDWasFetched) {
        testDone = immBrokerConsultMiFID.get('testDone');
        dateMiFIDWasMade = immBrokerConsultMiFID.get('fecha')
    }else {
        testDone = !immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'firstTimePerformingTest']);
        dateMiFIDWasMade = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'lastExecutionDate']);
    }
    let isValid = false;
    if (testDone) {
        const formatedDateMiFIDWasMade = moment(
            dateMiFIDWasMade,
            DATE_FORMAT_SLASHED_ES,
        );
        isValid = DateHelper.fromToday(formatedDateMiFIDWasMade).years() < 1;
    }
    return isValid;
};

const isRenderStep0 = () => {
    const flagBasedFeatures = getStore().getState().flagBasedFeatures;
    return isMiFIDValid() &&
        !!flagBasedFeatures.get(DISPLAY_CONVENIENCE_TEST_QUESTION_ZERO);
};


const isNotFirstTimePrefomingTest = () => {
    const immBrokerConsultMiFID = getStore().getState().brokerConsultMiFID;
    const immBrokerConvenienceMiFIDTest = getStore().getState().brokerConvenienceMiFIDTest;
    const immBrokerConsultMiFIDWasFetched = immBrokerConsultMiFID.get('fetched');
    let testDone;
    if(immBrokerConsultMiFIDWasFetched) {
        testDone = immBrokerConsultMiFID.get('testDone');
    }else {
        testDone = !immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'firstTimePerformingTest']);
    }
    return testDone;
}

const shouldCoherenceControl = () => {
    const flagBasedFeatures = getStore().getState().flagBasedFeatures;
    const coherenceControlFeatureFlag = flagBasedFeatures.get('convenience_test_less_score_warning');
    return isNotFirstTimePrefomingTest() &&
        coherenceControlFeatureFlag;
}

const setOrderNumber = (orderNumber) => {
    if(isRenderStep0()){
        return (parseInt(orderNumber)+1).toString();
    }
    return orderNumber;
}

module.exports = {
    isMiFIDValid,
    isRenderStep0,
    setOrderNumber,
    shouldCoherenceControl
};
